// Constantes de l'application Provéa

/** Page vitrine seule — header visible, pas de navigation inter-pages. */
export const SITE_LAUNCH_MODE = true;

/** Ancres de la page de lancement pour les entrées du menu. */
export const LAUNCH_NAV_SCROLL_MAP: Record<string, string> = {
  '/': '#accueil',
  '/nous-decouvrir': '#activite',
  '/acheter': '#programmes',
  '/nos-realisations': '#approche',
  '/acheter/terrains': '#territoire',
  '/vendre': '#contact',
};

export const APP_CONFIG = {
  name: 'Provéa',
  description: 'Aménagement & Promotion immobilière en Bretagne Sud',
  version: '1.0.0',
  url: 'https://provea-immo.fr',
  email: 'contact@provea-immo.fr',
  phone: '06 76 64 86 15',
} as const;

export const CONTACT_INFO = {
  address: {
    street: '123 Avenue de la République',
    city: 'Vannes',
    postalCode: '56000',
    country: 'France',
  },
  phone: '06 76 64 86 15',
  email: 'contact@provea-immo.fr',
  hours: 'Lun - Ven: 9h00 - 18h00',
} as const;

export const SOCIAL_LINKS = {
  linkedin: 'https://linkedin.com/company/promea',
  facebook: 'https://facebook.com/promea',
  twitter: 'https://twitter.com/promea',
} as const;

export const NAVIGATION_ITEMS = [
  {
    label: 'Découvrir',
    href: '/nous-decouvrir',
    children: [
      { label: 'Notre activité', href: '/' },
      { label: 'À propos', href: '/nous-decouvrir/a-propos' },
      { label: 'Espaces de ventes', href: '/nous-decouvrir/espaces-ventes' },
      { label: 'Engagements RSE', href: '/nous-decouvrir/rse' },
    ],
  },
  { label: 'Programmes', href: '/acheter' },
  { label: 'Terrains', href: '/acheter/terrains' },
  { label: 'Réalisations', href: '/nos-realisations' },
  { label: 'Actualité', href: '/blog' },
];

/** Menu header en mode lancement — sections de la page vitrine uniquement. */
export const LAUNCH_NAVIGATION_ITEMS = [
  { label: 'Accueil', href: '/' },
  { label: 'Notre activité', href: '/nous-decouvrir' },
  { label: 'Nos programmes', href: '/acheter' },
  { label: 'Notre approche', href: '/nos-realisations' },
  { label: 'Territoire', href: '/acheter/terrains' },
  { label: 'Contact', href: '/vendre' },
];

/** Liens footer en mode lancement. */
export const LAUNCH_FOOTER_LINKS = [
  {
    title: 'Provéa',
    items: [
      { label: 'Accueil', href: '/' },
      { label: 'Notre activité', href: '/nous-decouvrir' },
      { label: 'Nos programmes', href: '/acheter' },
      { label: 'Notre approche', href: '/nos-realisations' },
    ],
  },
  {
    title: 'Territoire',
    items: [
      { label: 'Bretagne Sud', href: '/acheter/terrains' },
      { label: 'Prospection foncière', href: '/nous-decouvrir' },
    ],
  },
  {
    title: 'Contact',
    items: [
      { label: 'Nous écrire', href: '/vendre' },
      { label: 'Proposer un foncier', href: '/vendre' },
    ],
  },
];

export const EXPERTISE_TYPES = {
  terrains: 'Terrains',
  collectif: 'Collectif',
  bureaux: 'Bureaux',
  activites: 'Activités',
} as const;

export const PROJECT_STATUS = {
  livre: 'Livré',
  'en-cours': 'En cours',
  planifie: 'Planifié',
} as const;

export const PROJECT_TYPES = {
  terrain: 'Terrains',
  collectif: 'Collectif',
  bureaux: 'Bureaux',
  activites: 'Activités',
} as const;

export const CONTACT_TYPES = {
  foncier: 'Foncier',
  institutionnel: 'Institutionnel',
  entreprise: 'Entreprise',
  investisseur: 'Investisseur',
} as const;

export const METHOD_STEPS = [
  {
    id: '1',
    title: 'Étude de faisabilité',
    description: 'Analyse du potentiel et des contraintes',
    duration: '2-4 semaines',
  },
  {
    id: '2',
    title: 'Acquisition',
    description: 'Négociation et acquisition du terrain',
    duration: '1-3 mois',
  },
  {
    id: '3',
    title: 'Conception',
    description: 'Programmation et design architectural',
    duration: '2-6 mois',
  },
  {
    id: '4',
    title: 'Autorisations',
    description: 'Démarches administratives et permis',
    duration: '3-12 mois',
  },
  {
    id: '5',
    title: 'Construction',
    description: 'Réalisation et suivi des travaux',
    duration: '6-24 mois',
  },
  {
    id: '6',
    title: 'Livraison',
    description: 'Remise des clés et accompagnement',
    duration: '1-2 mois',
  },
] as const;

export const RSE_COMMITMENTS = [
  {
    id: '1',
    title: 'Environnement',
    description: 'Intégration paysagère et respect de l\'environnement',
    category: 'environnement' as const,
  },
  {
    id: '2',
    title: 'Social',
    description: 'Création d\'emplois locaux et formation',
    category: 'social' as const,
  },
  {
    id: '3',
    title: 'Gouvernance',
    description: 'Transparence et éthique dans nos pratiques',
    category: 'gouvernance' as const,
  },
] as const;

export const FOOTER_LINKS = [
  {
    title: "S'installer ou investir",
    items: [
      { label: 'Habiter à Lyon', href: '/acheter?city=lyon' },
      { label: 'Habiter à Toulouse', href: '/acheter?city=toulouse' },
      { label: 'Habiter à Nîmes', href: '/acheter?city=nimes' },
      { label: 'Habiter à Pau', href: '/acheter?city=pau' },
    ],
  },
  {
    title: 'Vendre mon bien',
    items: [
      { label: 'Combien peut me rapporter ma vente?', href: '/vendre/vendre-a-promea' },
      { label: 'Vendre à Proméa', href: '/vendre/vendre-a-promea' },
    ],
  },
  {
    title: "S'installer avec Proméa",
    items: [
      { label: 'Futur proprio, pour le financement, on vous aide', href: '/nous-decouvrir' },
      { label: 'Avec Proméa je simule mon PTZ en 3 clics', href: '/acheter' },
      { label: 'Calcul frais de notaire', href: '/acheter' },
    ],
  },
  {
    title: 'Investir avec Proméa',
    items: [
      { label: 'Simulation capacité d\'emprunt', href: '/acheter' },
      { label: 'Calcul frais de notaire', href: '/acheter' },
    ],
  },
  {
    title: 'Univers Proméa',
    items: [
      { label: 'Notre vision', href: '/nous-decouvrir/a-propos' },
      { label: 'Nos innovations', href: '/nous-decouvrir' },
      { label: 'Nous rejoindre', href: '/nous-decouvrir' },
      { label: 'Actualités', href: '/blog' },
    ],
  },
];

export const SEO_CONFIG = {
  siteUrl: 'https://provea-immo.fr',
  siteName: 'Provéa',
  defaultTitle: 'Provéa | Programmes neufs et promotion immobilière en Bretagne Sud',
  defaultDescription:
    'Provéa, promoteur et aménageur en Bretagne Sud : programmes neufs, terrains à bâtir, logements et locaux professionnels. Découvrez nos opérations en commercialisation.',
  defaultOgImage: 'https://provea-immo.fr/images/Hero/hero-1.webp',
  locale: 'fr_FR',
  keywords: [
    'promotion immobilière',
    'programme neuf Bretagne',
    'aménageur Bretagne Sud',
    'terrains à bâtir Morbihan',
    'logements neufs Vannes',
    'promoteur immobilier Bretagne',
    'VEFA Bretagne Sud',
  ],
} as const;
